import React from 'react';
import config from '../../config';

export default function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    let yVals = payload.map((o) => parseFloat(o['value']));
    let yMax = Math.max(...yVals); // maximum value of competing foreasts e.g. short vs medium
    return (
      <div className='plot-tool-tip'>
        <div>{'🜄 ' + yMax.toFixed(2)}</div>
        <div>{'🕑 ' + config.formatDateTime(label)}</div>
      </div>
    );
  }
  return null;
}
